export const SAVE = 'stepDeclaration.SAVE';
export const VALUE_CHANGED = 'stepDeclaration.VALUE_CHANGED';
export const RESET = 'stepDeclaration.RESET';
export const LOAD = 'stepDeclaration.VALUE_LOAD';



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepDeclaration/constants.js